import { Max, Min } from 'class-validator';

export class AuctionUpdateOnWebsiteModel {
  @Min(1)
  @Max(1000000)
  public acceptablePrice: number;

  constructor(
    acceptablePrice: number
  ) {
    this.acceptablePrice = acceptablePrice;
  }
}
